import type { OrganisationRole } from '@pletly/database';

export const ROLES_TO_EDIT_CHATS: OrganisationRole[] = ['ADMIN', 'MANAGER'] as const;
